import script from "./ProductSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSlider.vue?vue&type=script&setup=true&lang=js"

import "@/styles/ProductSlider.scss?vue&type=style&index=0&id=641788da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641788da"]])

export default __exports__